import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Container from '../../../1stlog-ui/src/components/Container'
import Card from '../../../1stlog-ui/src/components/Card'
import LoaderOverlay from '../../../1stlog-ui/src/components/LoaderOverlay'
import TemplateEditor from './TemplateEditor'
import TemplateEditorButton from './TemplateEditor/TemplateEditorButton'
import TemplateList from './TemplateList'
import useTemplates from './useTemplates'

const Wrapper = styled(Container)`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  position: relative;
`

const Templates = (props) => {
  const {} = props

  const { isLoading } = useTemplates()

  return (
    <>
      <LoaderOverlay isLoading={isLoading} fullscreen />
      <TemplateEditor />
      <Wrapper className="mt-2">
        <h2>{i18n.t('order_templates', 'Auftragsvorlagen')}</h2>
        {/* <div className="mb-2">
          <TemplateEditorButton />
        </div> */}
        <Card noHeader>
          <TemplateList />
        </Card>
      </Wrapper>
    </>
  )
}

export default Templates
